module.exports = __webpack_public_path__ + "static/media/magnifying-glass-solid.0c9a1120.svg";